"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = require("babel-runtime/core-js/object/keys");

var _keys2 = _interopRequireDefault(_keys);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reduxForm = require("redux-form");

var _reactIntl = require("react-intl");

var _reactSelect = require("react-select");

var _reactSelect2 = _interopRequireDefault(_reactSelect);

var _pacomo = require("utils/pacomo");

var _forms = require("utils/forms");

var _components2 = require("components");

var _forms2 = require("metadata/forms");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var syncValidation = (0, _forms.formSyncValidation)({
    requiredValues: ["nationality"],
    dateValues: ["date_of_birth"]
});

var LoginForm = function LoginForm(_ref) {
    var intl = _ref.intl,
        handleSubmit = _ref.handleSubmit,
        error = _ref.error,
        invalid = _ref.invalid,
        pristine = _ref.pristine,
        submitting = _ref.submitting;

    var sortedOptions = [];
    (0, _keys2.default)(_forms2.formOptions.nationalityLabels).map(function (key) {
        sortedOptions.push(_forms2.formOptions.nationalityLabels[key]);
    });
    sortedOptions.sort(function (a, b) {
        return a.defaultMessage > b.defaultMessage ? 1 : -1;
    });
    return _react2.default.createElement(
        "div",
        { className: "login-form" },
        _react2.default.createElement(_components2.FormErrorMessage, { errorCode: error, submitting: submitting }),
        _react2.default.createElement(
            "form",
            null,
            _react2.default.createElement(
                "fieldset",
                { className: "form-group dob-group" },
                _react2.default.createElement(
                    "label",
                    null,
                    intl.formatMessage(_forms2.formLabels.dateOfBirth)
                ),
                _react2.default.createElement(_reduxForm.Field, {
                    id: "date_of_birth",
                    name: "date_of_birth",
                    component: _components2.SeparatedDateInput
                })
            ),
            _react2.default.createElement(
                "fieldset",
                { className: "form-group" },
                _react2.default.createElement(
                    "label",
                    { htmlFor: "nationality" },
                    intl.formatMessage(_forms2.formLabels.nationality)
                ),
                _react2.default.createElement(_reduxForm.Field, {
                    id: "nationality",
                    name: "nationality",
                    options: sortedOptions.map(function (item) {
                        return {
                            label: intl.formatMessage(item),
                            value: item.defaultMessage
                        };
                    }),
                    component: _components2.SelectInput
                })
            ),
            _react2.default.createElement(
                "div",
                null,
                _react2.default.createElement(
                    "button",
                    {
                        type: "submit",
                        className: "btn btn-success btn-lg btn-block",
                        disabled: invalid || pristine || submitting,
                        onClick: handleSubmit
                    },
                    intl.formatMessage(_forms2.formButtons.login)
                )
            )
        )
    );
};

LoginForm.propTypes = {
    intl: _propTypes2.default.object.isRequired,
    handleSubmit: _propTypes2.default.func.isRequired,
    error: _propTypes2.default.string,
    pristine: _propTypes2.default.bool,
    submitting: _propTypes2.default.bool
};

exports.default = (0, _reactIntl.injectIntl)((0, _reduxForm.reduxForm)({
    form: "login",
    validate: syncValidation
})((0, _pacomo.pacomoTransformer)(LoginForm)));
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./app/components/Login/LoginForm.js
// module id = 1302
// module chunks = 0